import { Action, Selector, StateContext, State, Store } from '@ngxs/store';
import { SuitabilityScore } from '../../models/agents/suitability-score';
import {
  RegisterScore,
  ApplyAgentInformation
} from '../actions/suitability-score.action';

export class SuitabilityScoreModel {
  suitabilityScore: SuitabilityScore;
  agentId?: string;
  personType?: string;
}

@State<SuitabilityScoreModel>({
  name: 'suitabilityScore',
  defaults: {
    suitabilityScore: null,
    agentId: null,
    personType: null
  }
})
export class SuitabilityScoreState {
  constructor(protected store: Store) {}

  @Selector()
  static score(state: SuitabilityScoreModel) {
    return state;
  }

  @Action(ApplyAgentInformation)
  applyAgentInformation(
    { patchState }: StateContext<SuitabilityScoreModel>,
    { payload }: any
  ) {
    patchState({ agentId: payload.agentId, personType: payload.personType });
  }

  @Action(RegisterScore)
  registerScore(
    { patchState }: StateContext<SuitabilityScoreModel>,
    { suitabilityScore }: RegisterScore
  ) {
    patchState({ suitabilityScore });
  }
}
